import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const CloneIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        viewBox="2 2 12 12"
        className="Icon clone"
        {...props}
    >
        <path
            fill="#1B2536"
            fillRule="evenodd"
            d="M14 8v4a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2zm-2-1H8a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zm-2-3v2H9V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h2v1H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2z"
        />
    </svg>
);
const Memo = memo(CloneIcon);
export default Memo;
